// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Add all variables here */
.angle-icon {
  font-size: 14px;
  flex-grow: 1;
  text-align: right;
}

:host.display-none {
  display: none;
}

:host {
  position: relative;
  font-size: 0.75rem;
  cursor: pointer;
  font-weight: 600;
  border: 1px solid #cacaca;
  background-color: white;
}
@media (min-width: 768px) {
  :host {
    padding: 1px 0;
    margin: 5px 10px 5px 0;
  }
  :host:hover .refinement {
    display: block;
  }
  :host:hover .refinement.rangeOnPrice {
    display: flex;
  }
  :host:hover .refinement.rangeOnVol {
    display: flex;
  }
  :host ::ng-deep .svg-inline--fa {
    vertical-align: -0.1em;
  }
}
@media (max-width: 767.98px) {
  :host .facet-title {
    padding: 14px 25px 5px;
  }
  :host .facet-sub-title {
    font-size: 10px !important;
    color: gray;
    padding: 0 25px 9px;
  }
  :host .refinement {
    display: block;
    overflow: visible;
    max-width: 100%;
  }
  :host .refinement.rangeOnPrice {
    display: flex;
  }
  :host .refinement.rangeOnVol {
    display: flex;
  }
}

.facets-selected {
  margin-left: 4px;
}

ais-range-slider::ng-deep .noUi-tooltip {
  border: 0;
}
ais-range-slider::ng-deep .noUi-connect {
  background-color: #5c0a31;
}

.refinement {
  display: none;
  position: absolute;
  top: 100%;
  left: 20px;
  z-index: 1;
  max-width: 360px;
  background-color: #fff;
  padding: 10px 24px 10px 10px;
  max-height: 400px;
  overflow-y: scroll;
  box-shadow: 1px 1px 5px 0 rgba(0, 0, 0, 0.4);
}
.refinement.rangeOnPrice {
  justify-content: center;
  flex-direction: column;
  padding: 20px;
  overflow: visible;
}
.refinement.rangeOnVol {
  height: 144px;
  justify-content: center;
  flex-direction: column;
  padding: 0 40px;
  overflow: visible;
}
.refinement::ng-deep ul {
  padding: 0;
}
.refinement::ng-deep ul .ais-RefinementList-item {
  list-style: none;
}
.refinement::ng-deep ul .ais-RefinementList-item .ais-RefinementList-label {
  margin: 0;
}
.refinement::ng-deep ul .ais-RefinementList-item .ais-RefinementList-labelText {
  cursor: pointer;
  margin-left: 10px;
}
.refinement::ng-deep ul .ais-RefinementList-item .ais-RefinementList-count {
  margin-left: 2px;
}

.fitOnMobilePriceSlider {
  margin-top: 2rem;
}

span {
  padding: 3px 14px;
}
span fa-icon {
  margin-left: 5px;
  vertical-align: middle;
}

.facet-values.expanded {
  display: block;
}
.facet-values > div.ais-refinement-list--item {
  display: block;
}
.facet-values > div.ais-refinement-list--item label {
  margin: 0;
  cursor: pointer;
}
.facet-values > div.ais-refinement-list--item input {
  cursor: pointer;
  margin-right: 10px;
}

@media (max-width: 767.98px) {
  :host {
    border-bottom: 1px solid #F9F9F9;
    border-top: 0;
    border-color: #cacaca;
  }
  :host span {
    border-right: none;
    font-size: 0.9rem;
    display: flex;
    text-transform: uppercase;
  }
  :host .flex-it {
    flex-grow: 1;
  }
  .angle-icon {
    font-size: 20px;
  }
  .refinement {
    box-shadow: none;
    width: 100%;
    position: unset;
    padding-left: 25px;
    padding-bottom: 0;
    max-height: none;
    border-top: 1px solid #F9F9F9;
    border-color: #cacaca;
  }
  .refinement::-webkit-scrollbar {
    -webkit-appearance: none;
  }
  .refinement::-webkit-scrollbar:vertical {
    width: 8px;
  }
  .refinement::-webkit-scrollbar:horizontal {
    height: 11px;
  }
  .refinement::-webkit-scrollbar-thumb {
    border-radius: 8px;
    border: 2px solid white; /* should match background, can't be transparent */
    background-color: rgba(0, 0, 0, 0.5);
  }
}
@media (max-width: 767.98px) {
  .hide-element-on-mobile-filter-facet {
    display: none;
  }
}
@media (min-width: 768px) {
  .hide-element-on-desktop-filter-facet {
    display: none;
  }
}
@media (max-width: 991.98px) {
  .fitOnMobilePriceSlider {
    padding-top: 52px;
    margin-top: 0 !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/variables.scss","webpack://./src/app/content/modules/page/components/search-page/components/top-filter-facet/top-filter-facet.component.scss","webpack://./node_modules/bootstrap/scss/mixins/_breakpoints.scss"],"names":[],"mappings":"AAAA,2BAAA;ACGA;EACE,eAAA;EACA,YAAA;EACA,iBAAA;AADF;;AAIA;EACE,aAAA;AADF;;AAIA;EACE,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EAEA,yBAAA;EACA,uBAAA;AAFF;AC6CI;EDlDJ;IAUI,cAAA;IACA,sBAAA;EADF;EAGI;IACE,cAAA;EADN;EAGM;IACE,aAAA;EADR;EAIM;IACE,aAAA;EAFR;EAME;IACE,sBAAA;EAJJ;AACF;ACwCI;EDjCA;IACE,sBAAA;EAJJ;EAOE;IACE,0BAAA;IACA,WAAA;IACA,mBAAA;EALJ;EAQE;IACE,cAAA;IACA,iBAAA;IACA,eAAA;EANJ;EAQI;IACE,aAAA;EANN;EASI;IACE,aAAA;EAPN;AACF;;AAYA;EACE,gBAAA;AATF;;AAcE;EACE,SAAA;AAXJ;AAcE;EACE,yBD1Ea;AC8DjB;;AAiBA;EACE,aAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EACA,gBAAA;EACA,sBAAA;EACA,4BAAA;EACA,iBAAA;EACA,kBAAA;EDtDA,4CAAA;ACyCF;AAeE;EACE,uBAAA;EACA,sBAAA;EACA,aAAA;EACA,iBAAA;AAbJ;AAgBE;EACE,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;AAdJ;AAqBI;EACE,UAAA;AAnBN;AAqBM;EACE,gBAAA;AAnBR;AAqBQ;EACE,SAAA;AAnBV;AAsBQ;EACE,eAAA;EACA,iBAAA;AApBV;AAuBQ;EACE,gBAAA;AArBV;;AA4BA;EACE,gBAAA;AAzBF;;AA4BA;EACE,iBAAA;AAzBF;AA2BE;EACE,gBAAA;EACA,sBAAA;AAzBJ;;AA+BE;EACE,cAAA;AA5BJ;AA+BE;EACE,cAAA;AA7BJ;AA+BI;EACE,SAAA;EACA,eAAA;AA7BN;AAgCI;EACE,eAAA;EACA,kBAAA;AA9BN;;AC9DI;EDmGF;IACE,gCD3Ia;IC4Ib,aAAA;IACA,qBAAA;EAjCF;EAmCE;IACE,kBAAA;IACA,iBAAA;IACA,aAAA;IACA,yBAAA;EAjCJ;EAoCE;IACE,YAAA;EAlCJ;EAuCA;IACE,eAAA;EArCF;EAwCA;IACE,gBAAA;IACA,WAAA;IACA,eAAA;IACA,kBAAA;IACA,iBAAA;IACA,gBAAA;IACA,6BDvKa;ICwKb,qBAAA;EAtCF;EAyCA;IACE,wBAAA;EAvCF;EA0CA;IACE,UAAA;EAxCF;EA2CA;IACE,YAAA;EAzCF;EA4CA;IACE,kBAAA;IACA,uBAAA,EAAA,kDAAA;IACA,oCAAA;EA1CF;AACF;AC1GI;EDyJF;IACE,aAAA;EA5CF;AACF;AC5HI;ED4KF;IACE,aAAA;EA7CF;AACF;ACpHI;EDwKF;IACE,iBAAA;IACA,wBAAA;EAjDF;AACF","sourcesContent":["/* Add all variables here */\n\n@import \"bootstrap/scss/functions\";\n@import \"bootstrap/scss/variables\";\n\n$text-orange: #F7941E;\n$wine-red-light: #5c0a31;\n$wine-red-dark: #3d051f;\n$wine-text-color: #37041c;\n$light-grey: #efefef;\n$yellow-cta: #ff9812;\n$gold: #e0b55d;\n$color-cloud-grey: #F9F9F9;\n$color-grey: #d5d5d5;\n$color-almost-black: #212529;\n$stock-green: #60E040;\n\n$supervin-color-bordeaux: #3E0523;\n\n$color-charcoal-black: #000;\n$theme-colors: (\n  \"primary\": $yellow-cta,\n  \"secondary\": $secondary,\n  \"success\": $yellow-cta, //$success,\n  \"info\": $yellow-cta, //$info,\n  \"warning\": $warning,\n  \"danger\": $danger,\n  \"light\": $light,\n  \"dark\": $dark\n);\n\n$container-max-widths: (\n  xl: 1280px\n);\n\n$header-height: 100px;\n\n$border-divider: 1px solid $color-cloud-grey;\n$breadcrumb-height: 30px;\n\n@mixin supervin-box-shadow {\n  box-shadow: 1px 1px 5px 0 rgba(0,0,0,0.4);\n}\n\n@mixin btn-primary {\n\n  border-radius: 0;\n  text-transform: uppercase;\n  padding: 0.7rem 1.3rem;\n  font-size: 0.8rem;\n  background-color: $yellow-cta;\n  border: solid 1px $yellow-cta;\n  display: inline-block;\n  font-weight: 400;\n  text-align: center;\n  vertical-align: middle;\n  user-select: none;\n  line-height: 1.5;\n  text-decoration: none;\n\n  &:hover {\n    text-decoration: none;\n  }\n}\n\n\n\n","@import \"src/variables\";\n@import \"bootstrap/scss/mixins/breakpoints\";\n\n.angle-icon {\n  font-size: 14px;\n  flex-grow: 1;\n  text-align: right;\n}\n\n:host.display-none {\n  display: none;\n}\n\n:host {\n  position: relative;\n  font-size: 0.75rem;\n  cursor: pointer;\n  font-weight: 600;\n\n  border: 1px solid #cacaca;\n  background-color: white;\n\n  @include media-breakpoint-up(md) {\n    padding: 1px 0;\n    margin: 5px 10px 5px 0;\n    &:hover {\n      .refinement {\n        display: block;\n\n        &.rangeOnPrice {\n          display: flex;\n        }\n\n        &.rangeOnVol {\n          display: flex;\n        }\n      }\n    }\n    ::ng-deep .svg-inline--fa {\n      vertical-align: -0.1em;\n    }\n  }\n  @include media-breakpoint-down(md) {\n    .facet-title {\n      padding: 14px 25px 5px;\n    }\n\n    .facet-sub-title {\n      font-size: 10px !important;\n      color: gray;\n      padding: 0 25px 9px;\n    }\n\n    .refinement {\n      display: block;\n      overflow: visible;\n      max-width: 100%;\n\n      &.rangeOnPrice {\n        display: flex;\n      }\n\n      &.rangeOnVol {\n        display: flex;\n      }\n    }\n  }\n}\n\n.facets-selected {\n  margin-left: 4px;\n}\n\nais-range-slider::ng-deep {\n\n  .noUi-tooltip {\n    border: 0;\n  }\n\n  .noUi-connect {\n    background-color: $wine-red-light;\n  }\n\n}\n\n.refinement {\n  display: none;\n  position: absolute;\n  top: 100%;\n  left: 20px;\n  z-index: 1;\n  max-width: 360px;\n  background-color: #fff;\n  padding: 10px 24px 10px 10px;\n  max-height: 400px;\n  overflow-y: scroll;\n\n  &.rangeOnPrice {\n    justify-content: center;\n    flex-direction: column;\n    padding: 20px;\n    overflow: visible;\n  }\n\n  &.rangeOnVol {\n    height: 144px;\n    justify-content: center;\n    flex-direction: column;\n    padding: 0 40px;\n    overflow: visible;\n  }\n\n  @include supervin-box-shadow;\n\n  &::ng-deep {\n\n    ul {\n      padding: 0;\n\n      .ais-RefinementList-item {\n        list-style: none;\n\n        .ais-RefinementList-label {\n          margin: 0;\n        }\n\n        .ais-RefinementList-labelText {\n          cursor: pointer;\n          margin-left: 10px;\n        }\n\n        .ais-RefinementList-count {\n          margin-left: 2px;\n        }\n      }\n    }\n  }\n}\n\n.fitOnMobilePriceSlider {\n  margin-top: 2rem;\n}\n\nspan {\n  padding: 3px 14px;\n\n  fa-icon {\n    margin-left: 5px;\n    vertical-align: middle;\n  }\n}\n\n.facet-values {\n\n  &.expanded {\n    display: block;\n  }\n\n  > div.ais-refinement-list--item {\n    display: block;\n\n    label {\n      margin: 0;\n      cursor: pointer;\n    }\n\n    input {\n      cursor: pointer;\n      margin-right: 10px;\n    }\n  }\n}\n\n@include media-breakpoint-down(md) {\n\n  :host {\n    border-bottom: $border-divider;\n    border-top: 0;\n    border-color: #cacaca;\n\n    span {\n      border-right: none;\n      font-size: 0.9rem;\n      display: flex;\n      text-transform: uppercase;\n    }\n\n    .flex-it {\n      flex-grow: 1;\n    }\n\n  }\n\n  .angle-icon {\n    font-size: 20px;\n  }\n\n  .refinement {\n    box-shadow: none;\n    width: 100%;\n    position: unset;\n    padding-left: 25px;\n    padding-bottom: 0;\n    max-height: none;\n    border-top: $border-divider;\n    border-color: #cacaca;\n  }\n\n  .refinement::-webkit-scrollbar {\n    -webkit-appearance: none;\n  }\n\n  .refinement::-webkit-scrollbar:vertical {\n    width: 8px;\n  }\n\n  .refinement::-webkit-scrollbar:horizontal {\n    height: 11px;\n  }\n\n  .refinement::-webkit-scrollbar-thumb {\n    border-radius: 8px;\n    border: 2px solid white; /* should match background, can't be transparent */\n    background-color: rgba(0, 0, 0, .5);\n  }\n}\n\n//mobile breakpoints start\n@include media-breakpoint-down(md) {\n  .hide-element-on-mobile-filter-facet {\n    display: none;\n  }\n}\n\n@include media-breakpoint-up(md) {\n  .hide-element-on-desktop-filter-facet {\n    display: none;\n  }\n}\n\n//mobile breakpoints end\n\n@include media-breakpoint-down(lg) {\n\n  .fitOnMobilePriceSlider {\n    padding-top: 52px;\n    margin-top: 0 !important;\n  }\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl xxl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @if not $n {\n    @error \"breakpoint `#{$name}` not found in `#{$breakpoints}`\";\n  }\n  @return if($n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width.\n// The maximum value is reduced by 0.02px to work around the limitations of\n// `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(md, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $max: map-get($breakpoints, $name);\n  @return if($max and $max > 0, $max - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min:  breakpoint-min($name, $breakpoints);\n  $next: breakpoint-next($name, $breakpoints);\n  $max:  breakpoint-max($next, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($next, $breakpoints) {\n      @content;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
